import { ProductMasterData } from '.';
import { EntityInput, forCreate, forDelete, forUpdate } from '../common/entity';

export class ProductMasterDataInput extends ProductMasterData implements EntityInput<ProductMasterData> {
  parseChildren<T extends ProductMasterData>(productMasterData: T) {
    if (productMasterData.dimensions) {
      (productMasterData.dimensions as any) = productMasterData.dimensions.parse();
    }

    if (productMasterData.grossWeight) {
      (productMasterData.grossWeight as any) = productMasterData.grossWeight.parse();
    }

    if (productMasterData.netWeight) {
      (productMasterData.netWeight as any) = productMasterData.netWeight.parse();
    }

    if (productMasterData.purchasePrice && productMasterData.purchasePrice.parse) {
      (productMasterData.purchasePrice as any) = productMasterData.purchasePrice.parse();
    }

    if (productMasterData.sellingPrice && productMasterData.sellingPrice.parse) {
      (productMasterData.sellingPrice as any) = productMasterData.sellingPrice.parse();
    }

    if (productMasterData.reorderPoint)
      (productMasterData.reorderPoint as any) = parseFloat(productMasterData.reorderPoint);

    return productMasterData;
  }

  forCreate(): CreateProductMasterDataInput {
    return {
      ...this,
      customFields: [...this.customFields.values()],
    };
  }

  forUpdate(): UpdateProductMasterDataInput {
    return this.parseChildren(
      UpdateProductMasterDataInput.from(
        { ...this, customFields: [...this.customFields.values()] },
        UpdateProductMasterDataInput,
      ),
    );
  }

  forDelete(): DeleteProductMasterDataInput {
    return DeleteProductMasterDataInput.from(
      { ...this, customFields: [...this.customFields.values()] },
      DeleteProductMasterDataInput,
    );
  }
}

export class CreateProductMasterDataInput extends forCreate(ProductMasterData) {}

export class UpdateProductMasterDataInput extends forUpdate(ProductMasterData) {}

export class DeleteProductMasterDataInput extends forDelete(ProductMasterData) {}
